module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/why/clapperboard-9d6f37d4c71372097c24aac2685a4df2.svg";